import React, { createContext, useContext } from 'react';

const UserContext = createContext({ emailVerified: false, setEmailVerified: () => {} });

export const useUserContext = () => useContext(UserContext);

export default UserContext;
